export default __webpack_public_path__ + "static/media/180.620cda0d.gif";